export default {"src":"/_next/static/media/drive-thru.7c4cc45f.svg","height":486,"width":486,"blurWidth":0,"blurHeight":0};